/**
 * @fileoverview JS - Class - Page.js
 * @author Adam Lemire
 * @since 2019/06/13
 * @version 1.0
 * @summary Dernières modifications : 2023/03/27
 */

/** @enum { string } */
export const PageType = {
  SINGLEMAPPAGE: 'SingleMapPage',
  MULTIMAPPAGE: 'MultiMapPage',
  DATAPAGE: 'DataPage',
  LAYOUTPAGE: 'LayoutPage' // ne dépend pas de Page.js
};

/**
 * @classdesc Classe Page, de type Template pour les sous-types de pages
 * @abstract
 */
export default class Page {
  /**
   * @param { number } id
   * @param { string } title
   * @param { PageType } pageType
   */
  constructor (id, title, pageType) {
    if (this.constructor === Page) {
      throw new Error('Ne peut instancier une classe abstraite');
    }

    /** @type { number } */
    this._id = id;
    /** @type { string } */
    this._title = title;
    /** @type { string } */
    this._iconUrl = '';
    /** @type { PageType } */
    this._pageType = pageType;
    this._titleChangedListeners = [];
  }

  get id () { return this._id; }

  get title () { return this._title; }

  set title (title) {
    this._title = title;
    this._notifyTitleChanged(title);
  }

  get pageType () { return this._pageType; }

  get iconUrl () { return this._iconUrl; }

  /** @abstract */
  refreshView () { throw new Error('Cette méthode doit être implémentée par la sous-classe!'); }

  /** @abstract */
  toJSON () { throw new Error('Cette méthode doit être implémentée par la sous-classe!'); }

  /**
   * @abstract
   * @param { string } jsonObject
   * */
  fromJSON (jsonObject) { throw new Error('Cette méthode doit être implémentée par la sous-classe!'); }

  _notifyTitleChanged (title) {}

  registerTitleChangedListener (listener) {
    const _this = this;
    this._titleChangedListeners.push(listener);
    this._notifyTitleChanged = function (element) {
      _this._titleChangedListeners.forEach(function (mListener) {
        mListener();
      });
    };
  }
}
